<template>
  <div class="sub-form-number sub-columns">
    <BaseInput name="min value" :validate="minValidator" class="sub-col" v-model="form.min" label="Min value"/>
    <BaseInput name="max value" validate="required|decimal" class="sub-col" v-model="form.max" label="Max value" hint="0 = no max value"/>
  </div>
</template>

<script>
  import subformMixin from '@/mixins/sub-form.mixin'

  export default {
    mixins: [ subformMixin ],
    data () {
      return {
        form: {
          min: '0',
          max: '200'
        }
      }
    },
    computed: {
      minValidator () {
        return `required|decimal${this.form.max == 0 ? '' : '|max_value:' + this.form.max }`
      }
    }
  }
</script>

<style lang="scss">

  .sub-form-number {
  }
</style>


// WEBPACK FOOTER //
// src/components/forms/sub-forms/SubFormNumber.vue